import { getBootstrapData } from '@experience/core-hostapp-share-lib';
import Cookies from 'universal-cookie';

import { getRuntimeConfig } from '@/shared/config/runtime';

import { client } from './generated/api/client.gen';

export { client };

let isConfigured = false;

/** Настраивает generated client на runtime API, cookie и impersonation headers. */
const configureClient = (): void => {
  if (isConfigured) {
    return;
  }

  // Включаем same-origin credentials и обязательный режим throwOnError.
  const runtimeApiUrl = getRuntimeConfig().VITE_RUNTIME_API_URL;

  client.setConfig({
    baseUrl: runtimeApiUrl || import.meta.env.VITE_API_URL || '',
    credentials: 'same-origin',
    throwOnError: true,
  });

  // Добавляем CSRF и legacy X-Requested-With на каждый запрос.
  client.interceptors.request.use((request) => {
    const csrfToken = new Cookies().get<string>('csrftoken');
    const { userId, isUnderImpersonalization } = getBootstrapData();

    if (userId !== null && isUnderImpersonalization) {
      request.headers.set('Impersonate', String(userId));
    } else {
      request.headers.delete('Impersonate');
    }

    if (csrfToken) {
      request.headers.set('x-csrftoken', csrfToken);
    }

    request.headers.set('x-requested-with', 'XMLHttpRequest');

    return request;
  });

  isConfigured = true;
};

/** Инициализирует API-клиент до рендера дочерних компонентов. */
export const initApiClient = (): typeof client => {
  configureClient();

  return client;
};
